/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./audio-asset-list.vue?vue&type=template&id=5afdd567&scoped=true&"
import script from "./audio-asset-list.vue?vue&type=script&lang=ts&"
export * from "./audio-asset-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afdd567",
  null
  
)

export default component.exports